import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const JobDescription = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 32 32"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.89228 4.86042C5.79848 4.08613 6.40288 3.4041 7.18284 3.4041H24.0914C24.879 3.4041 25.4857 4.09892 25.3795 4.87934L22.5085 25.9828C22.4209 26.6271 21.8706 27.1076 21.2204 27.1076H9.7391C9.08159 27.1076 8.5276 26.6166 8.44853 25.9639L5.89228 4.86042Z"
          fill="#CA35FF"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <mask
          id="mask0_7069_475"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="5"
          y="2"
          width="22"
          height="26"
        >
          <path
            d="M5.89228 4.86042C5.79848 4.08613 6.40288 3.4041 7.18284 3.4041H24.0914C24.879 3.4041 25.4857 4.09892 25.3795 4.87934L22.5085 25.9828C22.4209 26.6271 21.8706 27.1076 21.2204 27.1076H9.7391C9.08159 27.1076 8.5276 26.6166 8.44853 25.9639L5.89228 4.86042Z"
            fill="#FFDB59"
            stroke="#2B2F38"
            strokeWidth="1.4"
          />
        </mask>
        <g mask="url(#mask0_7069_475)">
          <path
            d="M5.62596 11.1146C5.62596 10.3967 6.20799 9.81462 6.92596 9.81462H13.3676C14.1332 9.81462 14.733 10.4729 14.662 11.2351L14.5457 12.4851C14.4834 13.1535 13.9225 13.6646 13.2513 13.6646H6.92596C6.20799 13.6646 5.62596 13.0826 5.62596 12.3646V11.1146Z"
            fill="#99E538"
            stroke="#2B2F38"
            strokeWidth="1.4"
          />
          <path
            d="M5.01287 15.0042C5.01287 13.7339 6.04261 12.7042 7.31287 12.7042H17.4434C18.7668 12.7042 19.8171 13.8181 19.7395 15.1391L19.3426 21.8891C19.2711 23.1049 18.2644 24.0542 17.0466 24.0542H7.31287C6.04261 24.0542 5.01287 23.0244 5.01287 21.7542V15.0042Z"
            fill="#99E538"
            stroke="#2B2F38"
            strokeWidth="1.4"
          />
          <line x1="6.6875" y1="18.09" x2="19" y2="18.09" stroke="#2B2F38" strokeWidth="1.4" />
          <path
            d="M7.57677 17.9938C7.57677 17.2758 8.1588 16.6938 8.87677 16.6938H10.7913C11.5392 16.6938 12.1329 17.3234 12.089 18.0701L12.0468 18.7876C12.0064 19.4748 11.4374 20.0113 10.7491 20.0113H8.87677C8.1588 20.0113 7.57677 19.4293 7.57677 18.7113V17.9938Z"
            fill="#99E538"
            stroke="#2B2F38"
            strokeWidth="1.4"
          />
        </g>
        <path
          d="M5.89228 4.86042C5.79848 4.08613 6.40288 3.4041 7.18284 3.4041H24.0914C24.879 3.4041 25.4857 4.09892 25.3795 4.87934L22.5085 25.9828C22.4209 26.6271 21.8706 27.1076 21.2204 27.1076H9.7391C9.08159 27.1076 8.5276 26.6166 8.44853 25.9639L5.89228 4.86042Z"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.3249 7.5487C22.7115 7.5487 23.0249 7.2353 23.0249 6.8487C23.0249 6.4621 22.7115 6.1487 22.3249 6.1487L20.7701 6.1487C20.3835 6.1487 20.0701 6.4621 20.0701 6.8487C20.0701 7.2353 20.3835 7.5487 20.7701 7.5487L22.3249 7.5487ZM9.46497 7.54884C9.85157 7.54884 10.165 7.23544 10.165 6.84884C10.165 6.46224 9.85157 6.14884 9.46497 6.14884L8.98299 6.14884C8.59639 6.14884 8.28299 6.46224 8.28299 6.84884C8.28299 7.23544 8.59639 7.54884 8.98299 7.54884L9.46497 7.54884ZM19.3416 6.8487C19.3416 7.2353 19.0282 7.5487 18.6416 7.5487L17.0868 7.5487C16.7002 7.5487 16.3868 7.2353 16.3868 6.8487C16.3868 6.4621 16.7002 6.1487 17.0868 6.1487L18.6416 6.1487C19.0282 6.1487 19.3416 6.4621 19.3416 6.8487ZM14.9941 7.54856C15.3807 7.54856 15.6941 7.23516 15.6941 6.84856C15.6941 6.46196 15.3807 6.14856 14.9941 6.14856L13.4393 6.14856C13.0527 6.14856 12.7393 6.46196 12.7393 6.84856C12.7393 7.23516 13.0527 7.54856 13.4393 7.54856L14.9941 7.54856Z"
          fill="#2B2F38"
        />
        <path
          d="M14.3261 15.6083L17.0328 28.2824L19.861 25.33L22.6689 28.8805L25.7975 26.0279L22.8919 22.7736L26.2346 20.2309L14.3261 15.6083Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default JobDescription
